import PageStore from "csi/page/PageStore";
import { C8Node, ICache } from "csi/typings";

export type PageStoreInitializer<T extends PageStore> = (node: C8Node, revisionNode: C8Node, cache: ICache) => Promise<T>;

/** initializer per node type */
const _pageStore: Record<string, PageStoreInitializer<PageStore>> = {};

/** create page store */
export async function createPageStore(node: C8Node, revisionNode: C8Node, cache: ICache): Promise<PageStore> {
	const initializer = _pageStore[node.$Type];
	const pageStore = await initializer?.(node, revisionNode, cache);

	return pageStore;
}

/** register the page store per node type */
export function registerPageStore<T extends PageStore>(nodeType: string, initializer: (node: C8Node, revisionNode: C8Node, cache: ICache) => Promise<T>): void {
	_pageStore[nodeType] = initializer;
}